import { PencilSimpleLine } from "@phosphor-icons/react";
import { useMemo, useState } from "react";

import { Button } from "common/components/ui/Button";
import WorkspaceImage from "common/components/WorkspaceImage";
import type { Workspace } from "common/types";

import MobileListTable from "../../../MobileListTable";
import ManageSeatsDrawer from "./ManageSeatsDrawer";

import type { ColumnDef } from "@tanstack/react-table";

export default function MobileList({
  workspaces,
  editingWorkspaceId,
  setEditingWorkspaceId,
}: {
  workspaces: Workspace[];
  editingWorkspaceId: string;
  setEditingWorkspaceId: (id: string) => void;
}) {
  const [isManageSeatsOpen, setIsManageSeatsOpen] = useState(false);

  const columns: ColumnDef<Workspace>[] = useMemo(
    () => [
      {
        id: "name",
        header: "Name",
        cell: ({
          row: {
            original: { id, icon_url, name },
          },
        }) => (
          <div className="flex gap-x-2 items-center">
            <WorkspaceImage id={id} imageSrc={icon_url} />
            <span className="text-sm-bold">{name}</span>
          </div>
        ),
      },
      {
        id: "licenses",
        header: "Accounts / Seats",
        cell: ({
          row: {
            original: { agency_license_count, accounts_count },
          },
        }) => (
          <div className="text-button-xs">
            <span>{accounts_count}</span>
            <span className="text-black-400">/{agency_license_count}</span>
          </div>
        ),
      },
      {
        id: "actions",
        cell: ({
          row: {
            original: { id },
          },
        }) => (
          <Button
            size="sm"
            intent="iconOnly"
            variant="ghost-black"
            onClick={() => {
              setEditingWorkspaceId(id);
              setIsManageSeatsOpen(true);
            }}
          >
            <PencilSimpleLine />
          </Button>
        ),
      },
    ],
    [],
  );

  return (
    <>
      <MobileListTable columns={columns} data={workspaces} isLoading={false} />
      {editingWorkspaceId && (
        <ManageSeatsDrawer
          workspace={workspaces.find(({ id }) => id === editingWorkspaceId)}
          isOpen={isManageSeatsOpen}
          setIsOpen={setIsManageSeatsOpen}
        />
      )}
    </>
  );
}
